import { sortBy } from 'lodash'
import { createSelector } from 'reselect'

export const createSortLogs = () =>
  createSelector(
    activityLogs => activityLogs,
    activityLogs => sortBy(activityLogs, 'date')
  )
